import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';

import { Table, TablePageEvent } from 'primeng/table';
import { SharedModule } from '../../../../shared/shared.module';
import { ContactService } from '../../../../services/contact.service';
import { CustomerService } from '../../../../services/customer.service';
import { contact } from '../../../../model/contact/contact.model';
import { HrmsService } from '../../../../services/hrms.service';
import { gridPageRequest } from '../../../../model/common/common.model';

@Component({
  selector: 'app-shift-component',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-shift-component.component.html',
  styleUrls: ['./list-shift-component.component.scss']

})
export class ListShiftComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  contactId: any;
  isEditMode: boolean = false;
  loader: boolean = false;
  employee: any[] = [];
  selectedShift: any[] = [];
  ShiftList: any[] = [];
  searchKey: string = '';

  constructor(
    @Optional() public ref: DynamicDialogRef,
    @Optional() public config: DynamicDialogConfig,
    private messageService: MessageService,
    private router: Router,
    private employeeService: HrmsService,
    private confirmationService: ConfirmationService

  ) { }

  submitted: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  contactDetails: contact[] = [];
  selectedType: string | null = null;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  shiftForm = new FormGroup({
    shiftName: new FormControl('', Validators.required),
    fromTime: new FormControl('', Validators.required),
    toTime: new FormControl('', Validators.required),
    weekendBasedOn: new FormControl('location', Validators.required),
    isActive: new FormControl(true),
    createdBy: new FormControl(''),
    updatedBy: new FormControl(''),
    createdDate: new FormControl(new Date()),
    updatedDate: new FormControl(null),
  });

  ngOnInit(): void {
    document.title = 'Shift List';
    this.searchEffect();
    this.getShift();

  }

  resetForm(form: FormGroup) {
    form.reset();
    _.forEach(form.controls, ctrl => ctrl.setErrors(null));
  }


  validateForm() {
    let isValid = true;
    if (this.shiftForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  cancel() {
    this.router.navigate(['/home/operations']);
  }

  getShift(): void {
    this.employeeService.getShift(this.pageRequest).subscribe({
      next: (data: any) => {
        if (data && data.employeeShifts) {
          this.ShiftList = data.employeeShifts;
        } else {
          this.ShiftList = [];
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  editShift(data?: any) {
    if (data) {
      const empData = data;
      this.router.navigate(['/home/create-shift'], { queryParams: { 'shiftId': empData.shiftId }, skipLocationChange: false, });
    } else {
      const empData = this.selectedShift[0];
      this.router.navigate(['/home/create-shift'], { queryParams: { 'shiftId': empData.shiftId }, skipLocationChange: false, });
    }

  }

  deleteShift() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var shiftIds = _.map(this.selectedShift, 'shiftId');

        this.employeeService.deleteShift(shiftIds).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Shift deleted successfully.' });
            this.loader = false;
            this.selectedShift = [];
            this.getShift();
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });

  }

  searchShift() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter search keyword' });
      return;
    }
    this.employeeService.autoSearchShift(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.ShiftList = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.reset();
    }
    this.searchKey = '';
    this.getShift();
  }

  loadEmployee(event: any) {
    if (this.searchKey)
      return;

    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + event.rows + 5;
    this.getShift();
  }

  formatShiftTime(fromTime: string, toTime: string): string {
    if (!fromTime || !toTime) return '';

    const formatTime = (timeStr: string) => {
      const [hoursStr, minutesStr] = timeStr.split(':');
      let hours = Number(hoursStr);
      const minutes = Number(minutesStr);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      if (hours === 0) hours = 12;
      return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    };

    return `${formatTime(fromTime)} to ${formatTime(toTime)}`;
  }

  
  placeholder: string = 'Search By ';
  private messages: string[] = ['Shift Name'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
